import { render, staticRenderFns } from "./NewsItemHeader.vue?vue&type=template&id=04aff628&"
import script from "./NewsItemHeader.vue?vue&type=script&lang=js&"
export * from "./NewsItemHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports